import styled, { css } from 'styled-components'
import { size, unit, color, fontSize, fontWeight } from 'ui/themes/utils'

import Icon from 'ui/blocks/Icon'
import InputField from 'ui/blocks/InputField'
import I from 'ui/elements/I'
import Div from 'ui/elements/Div'
import ButtonElement from 'ui/elements/Button'

export const PickerBlock = styled.div``

export const HorizontalWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
`

export const PickerForm = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: ${(props) => {
    return props.verticalAlignment || 'center'
  }};

  ${PickerBlock} {
    flex-basis: 100%;
  }

  & > ${Icon} {
    margin: 0 ${size('margin', 'sm')};
  }

  ${({ mode }) => mode === 'fixed_timeslots' && css`
    flex-flow: column nowrap;
    align-items: stretch;

    & > ${HorizontalWrapper} > ${Icon} {
      margin: 0 ${size('margin', 'sm')};
      margin-top: ${size('margin', 'lg')};
    }

    & > ${HorizontalWrapper} > ${PickerBlock} {
      flex-basis: 100%;
    }
  `}

  ${({ direction }) => direction === 'vertical' && css`
    flex-flow: column nowrap;
    align-items: stretch;

    & > ${HorizontalWrapper} {
      flex-flow: column nowrap;
      align-items: stretch;
    }
  `}
`

export const Label = styled.span`
  color: ${color('Text/Primary')};

  font-size: ${fontSize('sm')};
  font-weight: ${fontWeight('semibold')};
`

export const Field = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${unit('0.5')};
`

export const TimeslotLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;

  ${Label}:last-child {
    text-align: right;
  }
`

export const Button = styled(ButtonElement)`
  appearance: none;

  width: fit-content;

  border: none;
  border-bottom: ${unit('0.5')} solid ${color('Misc/Divider')};

  background-color: transparent;
  color: ${color('Text/Primary')};

  font-size: ${fontSize('lg')};
  font-weight: ${fontWeight('semibold')};

  line-height: 28px;

  padding: ${unit('0.5')} 0;

  border-radius: ${unit('2')} ${unit('2')} 0 0;

  text-align: left;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;

  cursor: pointer;

  transition: border-color 0.1s ease, padding 0.15s ease-in;

  &:disabled {
    border-bottom-color: transparent;

    color: ${color('Text/Tertiary')};

    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    border-color: ${color('Primary/Outline')};
  }

  ${({ empty }) => empty && css`
    color: ${color('Text/Tertiary')};
  `}

  ${({ error }) => error && css`
    border-color: ${color('Danger/Outline')};
    color: ${color('Danger/Outline')};

    &:disabled {
      color: ${color('Danger/Outline')};
    }
  `}

  ${({ active }) => active && css`
    background-color: ${color('Primary/Background2')};
    color: ${color('Primary/Outline')};
    border-color: ${color('Primary/Outline')};

    padding: ${unit('0.5')} ${unit('2')};
  `}
`

export const Timeslot = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;

  gap: ${unit('5')};

  ${Icon} {
    font-size: ${unit('4')};
  }
`

export const PickerWrapper = styled(Div)`
  display: flex;
  align-items: flex-end;

  gap: ${unit('4')};

  ${InputField} {
    margin-bottom: 0;
  }
`

export const Decorator = styled.div`
  align-self: flex-end;

  ${I} {
    color: ${color('Text/Primary')};

    font-size: 20px;

    transform: translateY(-3px);
  }
`
